module.exports = __webpack_public_path__ + "assets/img/map.bc2f40ce.png";